module.exports = __webpack_public_path__ + "img/0Q3B8790-7_H.67e4440b.webp";